import React, { Component } from 'react';
import DWUnifiedHeader from '../DWUnifiedHeader/DWUnifiedHeader';
import './top-menu.scss'
import { Configuration } from '../../types/Configuration';

type Props = {
    configuration: Configuration
    tokenIsProvided: boolean
    onLanguageChanged: (newLangauge:string) => void 
}

type State = {
    hasError: boolean
}

class TopMenu extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { hasError: false };
    }

    addError() {
        this.setState({ hasError: true });
    }

    removeError() {
        this.setState({ hasError: false });
    }

    render() {
        return (
            <div className={this.state.hasError ? "top-menu-container error" : "top-menu-container"}>
                <DWUnifiedHeader {... this.props}
                    onLoadCallback={this.removeError.bind(this)}
                    onErrorCallback={this.addError.bind(this)} />
            </div>
        )
    }
}

export default TopMenu;
